<ng-container *ngIf="!!get">
    <div>
        <tt-card class="col-xs-12 col-md-4 sp-5">
            <tt-input ttLabel="docpack_name" [(ttModel)]="get.docpack_name"></tt-input>
            <tt-input ttLabel="project_no_and_name" [(ttModel)]="get.project_no_and_name" ttReadonly></tt-input>
        </tt-card>
        <tt-card class="col-xs-12 col-md-4 sp-5">
            <tt-button ttText="docpack_generate_pdf" (ttClick)="generatePdf()" [ttLoading]="generatingPdf" ttIcon="fas fa-sync-alt"></tt-button>
            <tt-button ttText="dockpack_delete" ttIcon="fas fa-trash-alt" ttType="danger" (ttClick)="deleteValues()" [ttLoading]="deleting"></tt-button>
        </tt-card>
    </div>
    <tt-tabs #mainTabs>
        <tt-tab ttId="DOCUMENTS" ttLabel="gb_docpack_main_documents"></tt-tab>
        <tt-tab ttId="FRONTPAGE" ttLabel="gb_docpack_main_frontpage"></tt-tab>
    </tt-tabs>
    <tt-divider ttRememberId="w_docpack.dividers" [hidden]="mainTabs.ttSelectedId !== 'DOCUMENTS'" class="flex-1">
        <tt-divider-columns>
            <tt-divider-pane>
                <tt-grid *ngIf="!!chaptersGrid" [(ttOptions)]="chaptersGrid" (ttOnRowSelected)="onChapterRowSelected($event)"></tt-grid>
            </tt-divider-pane>
            <tt-divider-pane>
                <tt-doc-pack-chapter [params]="{ docpackchapter_keyno: this.get.docpackchapter_keyno_selected }" [styling]="format"></tt-doc-pack-chapter>
            </tt-divider-pane>
        </tt-divider-columns>
    </tt-divider>
    <tt-card *ngIf="mainTabs.ttSelectedId === 'FRONTPAGE'" class="flex-1" ttClass="flex-column flex-1 height-full">
        <div>
            <tt-button-save class="col-xs-12 col-md-3 sp-5" ttText="docpack_save" (ttClick)="save()" [ttLoading]="saving" [ttDisabled]="htmlProcessing"></tt-button-save>
            <tt-button class="col-xs-12 col-md-3 sp-5" ttText="docpack_html_update" ttIcon="fas fa-sync-alt" (ttClick)="reset()" [ttLoading]="resetting"></tt-button>
        </div>
        <tt-editor class="flex-1" ttLabel="html_text_frontpage" [(ttModel)]="get.html_text_frontpage" [(ttProcessing)]="htmlProcessing" ttHeight="100%"></tt-editor>
    </tt-card>
</ng-container>
<tt-toast *ngIf="firstRender && !get" class="col-xs-12 p-2" ttType="warning">
    <ng-container title> <span ttTranslateWord="could_not_find_doc_pack_with_id"></span> {{ params?.docpack_keyno }}. <span ttTranslateWord="check_if_the_item_has_been_deleted"></span> </ng-container>
</tt-toast>
